/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the QuotaInfo interface.
 */
export function instanceOfQuotaInfo(value) {
    if (!('limit' in value) || value['limit'] === undefined)
        return false;
    if (!('monthlyBalance' in value) || value['monthlyBalance'] === undefined)
        return false;
    if (!('packBalance' in value) || value['packBalance'] === undefined)
        return false;
    if (!('used' in value) || value['used'] === undefined)
        return false;
    return true;
}
export function QuotaInfoFromJSON(json) {
    return QuotaInfoFromJSONTyped(json, false);
}
export function QuotaInfoFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        ...json,
        'bonusGenerations': json['bonusGenerations'] == null ? undefined : json['bonusGenerations'],
        'limit': json['limit'],
        'monthlyBalance': json['monthlyBalance'],
        'packBalance': json['packBalance'],
        'periodEnd': json['periodEnd'] == null ? undefined : (new Date(json['periodEnd'])),
        'purchasedGenerations': json['purchasedGenerations'] == null ? undefined : json['purchasedGenerations'],
        'remaining': json['remaining'] == null ? undefined : json['remaining'],
        'used': json['used'],
    };
}
export function QuotaInfoToJSON(json) {
    return QuotaInfoToJSONTyped(json, false);
}
export function QuotaInfoToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        ...value,
        'bonusGenerations': value['bonusGenerations'],
        'limit': value['limit'],
        'monthlyBalance': value['monthlyBalance'],
        'packBalance': value['packBalance'],
        'periodEnd': value['periodEnd'] == null ? value['periodEnd'] : value['periodEnd'].toISOString(),
        'purchasedGenerations': value['purchasedGenerations'],
        'remaining': value['remaining'],
        'used': value['used'],
    };
}
